// extracted by mini-css-extract-plugin
module.exports = {"luckBg":"NineGrid_luckBg__9N_xA"};